import { Routes, Route, useLocation } from 'react-router-dom';

import SelectStoreByDate from './by-date/SelectStore';
import SelectDateByDate from './by-date/SelectDate';
import SelectStaffByDate from './by-date/SelectStaff';
import SelectServiceByDate from './by-date/SelectService';
import SelectTimeByDate from './by-date/SelectTime';
import ConfirmReservationByDate from './by-date/ConfirmReservation';

// ★ 追加：by-service
import SelectStoreByService from './by-service/SelectStore';
import SelectServiceByService from './by-service/SelectService';
import SelectDateByService from './by-service/SelectDate';
import SelectStaffByService from './by-service/SelectStaff';
import SelectTimeByService from './by-service/SelectTime';
import ConfirmReservationByService from './by-service/ConfirmReservation';

// ★ 追加：by-staff
import SelectStoreByStaff from './by-staff/SelectStore';
import SelectStaffByStaff from './by-staff/SelectStaff';
import SelectDateByStaff from './by-staff/SelectDate';
import SelectServiceByStaff from './by-staff/SelectService';
import SelectTimeByStaff from './by-staff/SelectTime';
import ConfirmReservationByStaff from './by-staff/ConfirmReservation';
import ReservationList from './ReservationList';
import ReservationHistory from './ReservationHistory';
import ReservationHistoryDetail from './ReservationHistoryDetail';
import BookingHub from './BookingHub';
import MenuCategoriesPage from './MenuCategoriesPage';
import StaffDirectoryPage from './StaffDirectoryPage';
import MyPage from './MyPage';
import ProfilePage from './ProfilePage';
import PointsPage from './PointsPage';

import BottomNav from '../../components/BottomNav';
import { ReserveProvider } from '../../contexts/useReserveContext';
import ReserveInitializer from '../../components/ReserveInitializer';
import ReserveTop from './ReserveTop';
import CustomerHeader from '../../components/CustomerHeader';

const ReservePage = () => {
  const location = useLocation();
  const isBookingStep = location.pathname.startsWith('/reserve/by-');
  const isReserveHome = location.pathname === '/reserve' || location.pathname === '/reserve/';

  return (
    <ReserveProvider>
      <ReserveInitializer />

      <div
        className={`min-h-screen flex flex-col ${
          isReserveHome
            ? 'bg-[radial-gradient(circle_at_top,#e7f6f2_0%,#f8fafc_48%,#eef4f8_100%)]'
            : 'bg-gradient-to-b from-[#f3fbf9] via-white to-[#eef7fb]'
        }`}
        style={{
          ['--reserve-step-top' as string]: isBookingStep ? '76px' : '132px',
          ['--reserve-footer-bottom' as string]: isBookingStep
            ? 'calc(var(--bottom-nav-space) + 12px)'
            : '80px',
          ['--bottom-nav-space' as string]: '108px',
        }}
      >
        <CustomerHeader subtitle={isBookingStep ? 'Book Appointment' : ''} compact={isBookingStep} />

        <main
          className={`flex-1 ${isReserveHome ? 'px-0 pt-0' : 'px-4 pt-5'}`}
          style={{
            paddingBottom: isBookingStep
              ? 'calc(var(--bottom-nav-space) + env(safe-area-inset-bottom) + 24px)'
              : 'calc(var(--bottom-nav-space) + env(safe-area-inset-bottom))',
          }}
        >
          <div className="max-w-lg mx-auto space-y-4">
            <Routes>
              <Route path="/" element={<ReserveTop />} />
              <Route path="/booking" element={<BookingHub />} />
              <Route path="/menu" element={<MenuCategoriesPage />} />
              <Route path="/menu/:categoryId" element={<MenuCategoriesPage />} />
              <Route path="/staff" element={<StaffDirectoryPage />} />
              <Route path="/mypage" element={<MyPage />} />
              <Route path="/points" element={<PointsPage />} />
              <Route path="/profile" element={<ProfilePage />} />

              {/* ★ 日付起点フロー */}
              <Route path="/by-date/store" element={<SelectStoreByDate />} />
              <Route path="/by-date/date" element={<SelectDateByDate />} />
              <Route path="/by-date/staff" element={<SelectStaffByDate />} />
              <Route path="/by-date/service" element={<SelectServiceByDate />} />
              <Route path="/by-date/time" element={<SelectTimeByDate />} />
              <Route path="/by-date/confirm-reservation" element={<ConfirmReservationByDate />} />

              {/* ★ サービス起点フロー */}
              <Route path="/by-service/store" element={<SelectStoreByService />} />
              <Route path="/by-service/service" element={<SelectServiceByService />} />
              <Route path="/by-service/date" element={<SelectDateByService />} />
              <Route path="/by-service/staff" element={<SelectStaffByService />} />
              <Route path="/by-service/time" element={<SelectTimeByService />} />
              <Route
                path="/by-service/confirm-reservation"
                element={<ConfirmReservationByService />}
              />

              {/* ★ スタッフ起点フロー */}
              <Route path="/by-staff/store" element={<SelectStoreByStaff />} />
              <Route path="/by-staff/staff" element={<SelectStaffByStaff />} />
              <Route path="/by-staff/date" element={<SelectDateByStaff />} />
              <Route path="/by-staff/service" element={<SelectServiceByStaff />} />
              <Route path="/by-staff/time" element={<SelectTimeByStaff />} />
              <Route
                path="/by-staff/confirm-reservation"
                element={<ConfirmReservationByStaff />}
              />

              {/* ★ 予約管理（キャンセル） */}
              <Route path="/list" element={<ReservationList />} />
              <Route path="/history" element={<ReservationHistory />} />
              <Route path="/history/:reservationId" element={<ReservationHistoryDetail />} />
            </Routes>
          </div>
        </main>

        <BottomNav />
      </div>
    </ReserveProvider>
  );
};

export default ReservePage;
